export const ContractSchedule = {
  expired: 'expired',
  ongoing: 'ongoing',
  upcoming: 'upcoming',
}
